export const tableContainerStyle = {
    maxHeight: '457px',
    minWidth: 800,
    position: 'relative',
    minHeight: '457px'
};